import { AccountingType } from "v2-types/order";
import { ChargeFormEntry } from "./types";
import { ListingEntry } from "graphql/listings/queries";

export const formatAccountingData = (accountingData: AccountingType[], lockedCharges: ListingEntry[]): ChargeFormEntry[] =>
  accountingData.map((charge) => {
    const disabled = (Number(charge.number) === 703 && charge.letter === "L")
    || lockedCharges.some((listing) => listing.code === charge.code);

    return ({
      accounting_id: charge._id,
      description: charge.description,
      kind: charge.kind,
      number: Number(charge.number),
      months: charge.months_advanced || 0,
      per_month: charge.per_month || 0,
      tax: charge.involved_parties
        .filter((party) => party.kind.includes('Tax'))
        .map((data) => data.amount)
        .reduce((partialSum, a) => partialSum + a, 0),
      payees: charge.involved_parties
        .filter((party) => party.kind.includes('Payee'))
        .map((payee) => ({
          ...payee
        })),
      payers: charge.involved_parties
        .filter((party) => party.kind.includes("Payer"))
        .map((payer) => ({
          ...payer
        })),
      taxes: charge.involved_parties
        .filter((party) => party.kind.includes("Tax"))
        .map((tax) => ({
          ...tax
        })),
      payee_id: charge.involved_parties
        .filter((party) => party.kind.includes('Payee'))
        .map((p) => p._id)
        .join(','),
      seller_before:
      charge.involved_parties.reduce((prev, curr) => {
        if (curr.order_kinds.includes('Seller') && curr.kind.includes('Payer')) {
          return prev + curr.before_closing_amount;
        }
        return prev;
      }, 0) || 0,
      seller_at:
      charge.involved_parties.reduce((prev, curr) => {
        if (curr.order_kinds.includes('Seller') && curr.kind.includes('Payer')) {
          return prev + curr.at_closing_amount;
        }
        return prev;
      }, 0) || 0,
      buyer_before:
      charge.involved_parties.reduce((prev, curr) => {
        if (curr.order_kinds.includes('Buyer') && curr.kind.includes('Payer')) {
          return prev + curr.before_closing_amount;
        }
        return prev;
      }, 0) || 0,
      buyer_at:
      charge.involved_parties.reduce((prev, curr) => {
        if (curr.order_kinds.includes('Buyer') && curr.kind.includes('Payer')) {
          return prev + curr.at_closing_amount;
        }
        return prev;
      }, 0) || 0,
      by_others:
      charge.involved_parties.reduce((prev, curr) => {
        if (
          !curr.order_kinds.includes('Buyer') &&
          !curr.order_kinds.includes('Seller') &&
          curr.kind.includes('Payer')
        ) {
          return prev + curr.amount;
        }
        return prev;
      }, 0) || 0,
      letter: charge.letter || '',
      amount: charge.amount,
      amount_override: charge.amount_override > 0 ? charge.amount_override : charge.amount,
      amount_calculated: charge.amount_calculated,
      disabled,
      code: charge.code
    });
  });

export const sliceText = (text: string, maxLength: number) => text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

export const getAccountingLetter = (letter: string) => {
  const hudL = ["700", "800", "900", "1000", "1100", "1200", "1300"];
  if (hudL.includes(letter)) return "L";

  return letter;
};